module.exports = __webpack_public_path__ + "static/media/CooperHewitt-Semibold.0412d59f.woff";